"use client";

import { useFooter } from "@/hooks/customer/useHeader";
import Image from "next/image";
import Link from "next/link";

import { FiChevronDown, FiPhone, FiShield } from "react-icons/fi";

const FooterMobile = () => {
  const { handleSelectNavigate } = useFooter();

  return (
    <footer className="w-full px-4 pt-8 pb-12 lg:hidden bg-white">
      <div className="flex justify-between items-center mb-3">
        <Image
          src="/images/logo1.png"
          alt="Trips Adora logo"
          width={112}
          height={24}
          className="object-contain w-28 h-6"
        />
        {/* contact info */}
        <div>
          <h3 className="font-bold mb-3">Follow Us</h3>
          <div className="flex gap-3">
            {/* Facebook */}
            <Link
              href="https://web.facebook.com/profile.php?id=61586602331134"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our Facebook page"
              className="w-8 h-8 border border-black rounded-full flex items-center justify-center"
            >
              <svg
                className="w-4 h-4 text-black"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M24 12.073c0-6.627-5.373-12-12-12S0 5.446 0 12.073C0 18.1 4.388 23.064 10.125 23.964v-8.385H7.078v-3.506h3.047V9.413c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.251h3.328l-.532 3.506h-2.796v8.385C19.612 23.064 24 18.1 24 12.073z" />
              </svg>
            </Link>

            {/* X / Twitter */}
            <Link
              href="https://x.com/tripsadora"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our X page"
              className="w-8 h-8 border border-black rounded-full flex items-center justify-center"
            >
              <svg
                className="w-4 h-4 text-black"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M18.25 2H21l-6.5 7.43L22 22h-5.5l-4.03-5.7L7.7 22H5l7-8L4 2h5.62l3.64 5.18L18.25 2zM8.24 4l8.52 12h-1.99L6.24 4h2z" />
              </svg>
            </Link>

            {/* Pinterest */}
            <Link
              href="https://jp.pinterest.com/tripsadora/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our Pinterest page"
              className="w-8 h-8 border border-black rounded-full flex items-center justify-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 90 90"
              >
                <path
                  d="M 25.334 90 c 3.415 -2.853 8.943 -12.256 10.189 -17.048 c 0.671 -2.581 3.437 -13.114 3.437 -13.114 c 1.799 3.43 7.054 6.334 12.644 6.334 c 16.638 0 28.626 -15.301 28.626 -34.312 C 80.229 13.636 65.357 0 46.22 0 C 22.415 0 9.771 15.981 9.771 33.382 c 0 8.091 4.307 18.164 11.198 21.371 c 1.045 0.486 1.604 0.272 1.845 -0.738 c 0.183 -0.767 1.113 -4.513 1.532 -6.256 c 0.134 -0.557 0.068 -1.036 -0.383 -1.582 c -2.279 -2.764 -4.105 -7.848 -4.105 -12.589 c 0 -12.167 9.213 -23.94 24.909 -23.94 c 13.552 0 23.042 9.235 23.042 22.443 c 0 14.923 -7.536 25.261 -17.341 25.261 c -5.415 0 -9.469 -4.478 -8.169 -9.968 c 1.555 -6.558 4.569 -13.634 4.569 -18.367 c 0 -4.237 -2.274 -7.771 -6.98 -7.771 c -5.536 0 -9.982 5.727 -9.982 13.397 c 0 4.886 1.65 8.19 1.65 8.19 s -5.467 23.115 -6.469 27.421 c -1.109 4.764 -0.674 11.476 -0.191 15.84 L 25.334 90 z"
                  fill="#000000"
                />
              </svg>
            </Link>

            {/* Instagram */}
            <Link
              href="https://www.instagram.com/tripsadora/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our Instagram page"
              className="w-8 h-8 border border-black rounded-full flex items-center justify-center"
            >
              <svg
                className="w-4 h-4 text-black"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="3" width="18" height="18" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17" cy="7" r="0.8" />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      <hr className="bg-[#898989]" />

      <div className="my-3 flex justify-between">
        {/* left side */}
        <div className="space-y-3 w-2/5">
          {/* Company */}
          <div className="relative">
            <label htmlFor="company-select" className="sr-only">
              Company
            </label>
            <select
              id="company-select"
              onChange={handleSelectNavigate}
              className="appearance-none bg-transparent border-b border-[#898989] p-1 text-xs text-black focus:outline-none focus:ring-2 focus:ring-primary w-full"
            >
              <option value="">Company</option>
              <option value="/about-us">About Us</option>
              <option value="/sitemap">Sitemaps</option>
              <option value="/contact-us">Contact Us</option>
            </select>
            <FiChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-3 h-3 text-black pointer-events-none" />
          </div>

          {/* Support */}
          <div className="relative">
            <label htmlFor="support-select" className="sr-only">
              Support
            </label>
            <select
              id="support-select"
              onChange={handleSelectNavigate}
              className="appearance-none bg-transparent border-b border-[#898989] p-1 text-xs text-black focus:outline-none focus:ring-2 focus:ring-primary w-full"
            >
              <option value="">Support</option>
              <option value="/support">Help Center</option>
              <option value="/contact-us">Feedback</option>
              <option value="/faq">FAQs</option>
              <option value="/privacy-policy">Privacy Policy</option>
            </select>
            <FiChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-3 h-3 text-black pointer-events-none" />
          </div>

          {/* Partner With Us */}
          <div className="relative">
            <label htmlFor="partner-select" className="sr-only">
              Partner With Us
            </label>
            <select
              id="partner-select"
              onChange={handleSelectNavigate}
              className="appearance-none bg-transparent border-b border-[#898989] p-1 text-xs text-black focus:outline-none focus:ring-2 focus:ring-primary w-full"
            >
              <option value="">Partner With Us</option>
              <option value="/become-supplier">Become a Partner</option>
              <option value="/collaborate">Collaboration With Us</option>
              <option value="/write-for-us">Write For Us</option>
            </select>
            <FiChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-3 h-3 text-black pointer-events-none" />
          </div>

          {/* Explore */}
          <div className="relative">
            <label htmlFor="explore-select" className="sr-only">
              Explore
            </label>
            <select
              id="explore-select"
              onChange={handleSelectNavigate}
              className="appearance-none bg-transparent border-b border-[#898989] p-1 text-xs text-black focus:outline-none focus:ring-2 focus:ring-primary w-full"
            >
              <option value="">Explore</option>
              <option value="/blog">TripsAdora Blogs</option>
              <option value="/trip-cash">Trip Cash+</option>
              <option value="/refer-earn">Refer And Earn</option>
              <option value="/write-review">Write A Review</option>
            </select>
            <FiChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-3 h-3 text-black pointer-events-none" />
          </div>
        </div>
        {/* right side */}
        <div className="space-y-3 w-2/5">
          <span className="span-text text-black font-medium">
            Secure Payment Channels
          </span>
          <div className="flex flex-wrap gap-4">
            <Image
              src="/images/pay1.png"
              alt="Payment method 1"
              width={28}
              height={28}
              className="w-7 h-auto object-contain"
            />
            <Image
              src="/images/pay3.png"
              alt="Payment method 2"
              width={28}
              height={28}
              className="w-7 h-auto object-contain"
            />
            <Image
              src="/images/pay8.png"
              alt="Payment method 3"
              width={28}
              height={28}
              className="w-7 h-auto object-contain"
            />
            <Image
              src="/images/pay2.png"
              alt="Payment method 4"
              width={28}
              height={28}
              className="w-7 h-auto object-contain"
            />
            <Image
              src="/images/pay9.png"
              alt="Payment method 5"
              width={28}
              height={28}
              className="w-7 h-auto object-contain"
            />
            <Image
              src="/images/pay4.png"
              alt="Payment method 6"
              width={28}
              height={28}
              className="w-7 h-auto object-contain"
            />
            <Image
              src="/images/pay11.png"
              alt="Payment method 7"
              width={28}
              height={28}
              className="w-7 h-auto object-contain"
            />
            <Image
              src="/images/pay6.png"
              alt="Payment method 8"
              width={28}
              height={28}
              className="w-7 h-auto object-contain"
            />
          </div>

          <div className="pt-3 space-y-2">
            <div className="flex items-center gap-1">
              <FiPhone className="w-4 h-4 text-black" />
              <span className="span-text text-black font-medium">
                +817092256870
              </span>
            </div>

            <div className="flex items-center gap-1">
              <FiShield className="w-4 h-4 text-black" />
              <span className="span-text text-black font-medium">
                Secure Booking
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* copyright */}
      <p className="py-2 text-center text-[6px]">
        © 2026 TripsAdora. All rights reserved.
      </p>
    </footer>
  );
};

export default FooterMobile;
